import { performRequest } from "../performRequest"



export const getAllResumeApi = (params) => {
    return performRequest("get", "api/ess/job-applicant/",params)
}

export const getResumeDetailApi = (id, params) => {
    return performRequest("get", `api/ess/job-applicant/${id}/`,params)
}


export const statusChangeResumeApi = (params, id) => {
    return performRequest("patch", `api/ess/job-applicant/${id}/`,params)
}

export const updateJobApplicantSlotApi = (id, params) => {
    const company = localStorage.getItem('company') || 1;
    return performRequest("patch", `api/ess/job-applicant/${id}/`, { company, ...params });
}





export const getAllResumeInternalApi = (params) => {
    return performRequest("get", "api/ess/job-applicant-internal/",params)
}

export const exportResumeApi = (id) => {
    return performRequest("get", `api/ess/job-applicant/${id}/export/`, {}, true, "blob")
}
